var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-tabs',{staticClass:"tabs",model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Design","name":"Design"}},[_c('Home')],1),_c('el-tab-pane',{attrs:{"label":"Preview","name":"Preview"}},[_c('Preview')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }